export var ServiceType;
(function (ServiceType) {
    ServiceType["Meal"] = "Meal";
    ServiceType["Baggage"] = "Baggage";
    ServiceType["Seats"] = "Seats";
    ServiceType["Transfer"] = "Transfer";
    ServiceType["Insurance"] = "Insurance";
})(ServiceType || (ServiceType = {}));
